import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Center,
  Heading,
  HStack,
  IconButton,
  Skeleton,
  Stack,
  StackProps,
} from "@chakra-ui/react";
import * as React from "react";
import { Link } from "react-router-dom";
import { ColorModeSwitcher } from "../components/shared/ColorModeSwitcher";
import { Logo } from "../components/shared/Logo";
import { MaterialIcon } from "../components/shared/MaterialIcon";
import { ProfileDropdown } from "../components/shared/ProfileDropdown";
import { useAuth } from "../providers/AuthProvider";
import { useToggleSidebarOpen } from "./store/actions/useToggleSidebarOpen";
import { useSelectIsSidebarOpen } from "./store/select/useSelectIsSidebarOpen";

interface IProps extends StackProps {
  isLoading?: boolean;
  isError?: boolean;
  title: string;
  back?: {
    title: string;
    to: string;
  };
  headerElement?: React.ReactNode;
  children?: React.ReactNode;
  isIncludeProfile?: boolean;
}

export const PageHeader = (props: IProps) => {
  const {
    isLoading = false,
    isError = false,
    title,
    back,
    isIncludeProfile,
    headerElement,
    ...rest
  } = props;

  const { userProfile } = useAuth();

  const toggleSidebarOpen = useToggleSidebarOpen();
  const isSidebarOpen = useSelectIsSidebarOpen();

  return (
    <HStack
      justify={"space-between"}
      spacing={{ base: "4", lg: "24" }}
      px={"4"}
      shadow="sm"
      borderBottom={"1px"}
      borderColor="border"
      w="full"
      alignItems={"center"}
      py="4"
      {...rest}
    >
      <HStack flex={1} spacing={4}>
        {!isSidebarOpen && (
          <Box>
            <IconButton
              variant={"ghost"}
              onClick={toggleSidebarOpen}
              icon={<MaterialIcon name="menu" fontSize="2rem" />}
              aria-label="close menu"
            ></IconButton>
          </Box>
        )}

        <Stack spacing={0}>
          <Breadcrumb justifyContent={"center"} display="flex">
            {back && (
              <BreadcrumbItem>
                <BreadcrumbLink as={Link} to={back.to}>
                  <Heading size="md">{back.title}</Heading>
                </BreadcrumbLink>
              </BreadcrumbItem>
            )}

            {!isError && (
              <BreadcrumbItem isCurrentPage>
                <Skeleton isLoaded={!isLoading}>
                  <BreadcrumbLink href="#">
                    <Heading
                      size="md"
                      noOfLines={1}
                      maxW={{ base: "14rem", xl: "full" }}
                    >
                      {title}
                    </Heading>
                  </BreadcrumbLink>
                </Skeleton>
              </BreadcrumbItem>
            )}
          </Breadcrumb>
        </Stack>
        {headerElement && headerElement}
      </HStack>
      <Center>
        <Logo.Base h="10" />
      </Center>
      <HStack flex={1} justifyContent="flex-end">
        {props.children && (
          <HStack direction="row" spacing="4">
            {props.children}
          </HStack>
        )}

        {isIncludeProfile && (
          <HStack spacing="6">
            {userProfile.is_admin && (
              <Box
                rounded="md"
                px={4}
                py={2}
                bg="bg.contrast"
                color="text.contrast"
              >
                Admin View
              </Box>
            )}
            <ColorModeSwitcher></ColorModeSwitcher>
            <ProfileDropdown />
          </HStack>
        )}
      </HStack>
    </HStack>
  );
};
